export const getNextTickerSlide = (index, length, itemsPerSlide) => {
    if (length <= 0 || itemsPerSlide <= 0) {
        return { index: 0, completedCycle: false }
    }

    const normalizedIndex = index % length
    const nextIndex = normalizedIndex + itemsPerSlide
    if (nextIndex >= length) return { index: 0, completedCycle: true }
    return { index: nextIndex, completedCycle: false }
}
